const en = {
  uxcore: 'UX Core',
  ai: 'Artificial Intelligence & Vibecoding',
  thoughts: 'Thoughts',
  pm: 'Project Management',
  uxcoreId: 'UX Core',
  aiId: 'AI',
  thoughtsId: 'Thoughts',
  pmId: 'Project Management',
};

export default en;
